/* global myModal, analyticEventTracker, isReservationModificationNotAllowed, cancellation */

var myBooking = {
    mode: false,
    form: false,
    isActionsLoading: false,
    init: function() {
        myBooking.signIn();
        myBooking.actions();
        myBooking.externalCoverage();
        myBooking.prefix();
        myBooking.bookingCard();
        myBooking.checklist();
        myBooking.alternativeModal();
        myBooking.alternativeOfferExpire();
        myBooking.modifyNotAllowedModal();
    },
    externalCoverage() {
        if (_d.page !== 'reservation-show') {
            return;
        }

        $('.full-protection-inclusion-title').on('click', function() {
            const that = $(this);

            that.toggleClass('opened');
            that.parent().find('.full-protection-inclusion-content').slideToggle();
        });

        $('#addFCMyBooking').on('click', function(e) {
            e.preventDefault();
            const that = $(this);

            that.addClass('loading').prop('disabled', true);

            analyticEventTracker.sendInstantEvent('My_Booking_Add_FC', that.data());

            window.localStorage.setItem('insuranceAdded', that.data('attributeReservation'));

            $.postJSON(_d.url.reservation.modification.request, $('#fc-upsale-form').serialize(), function() {
                setTimeout(function() {
                    window.location.href = _d.url.c.replace('/confirmation/', '/show/');
                }, 2000);
            });
        });
    },
    actions: function() {
        $('#phone-cta').on('click', function() {
            if ($(this).hasClass('pointer')) {
                $(this).removeClass('pointer');
                $(this).children('div').text(_d.phones.support);
            }
        });
        $('.trigger-gtm-pick-up-instructions-click').on('click', function() {
            window.hj=window.hj||function() { (hj.q=hj.q||[]).push(arguments); }; //make sure we can reach out window.hj attribute
            window.hj('trigger', 'pickupInstructions');
        });
    },
    signIn: function() {
        $('.my-booking-btn').on('click', function(e) {
            e.preventDefault();
            var btn = $(this);

            if (btn.hasClass('loading')) {
                return false;
            }

            btn.addClass('loading');

            myBooking.form = btn.data('form');
            myBooking.mode = btn.data('mode');

            $('#'+ myBooking.form).submit();
        });


        $('.my-booking-forms').each(function() {  // attach to all form elements on page
            $(this).validate({
                errorClass: 'error',
                focusInvalid: false,
                errorElement: 'div',
                rules: {
                    booking_number: {
                        required: true
                    },
                    booking_email: {
                        validate_email: true
                    }
                },
                errorPlacement: function(error, el) {
                    $(el).next().html(error);
                },
                highlight: function(el, ec) {
                    $(el).addClass(ec);
                },
                unhighlight: function(el, ec) {
                    $(el).removeClass(ec);
                },
                invalidHandler: function() {
                    setTimeout(function() {
                        myBooking.enableBtn();
                    }, 10);
                },
                submitHandler: function() {
                    const bookingNumber = String($('#my-booking-number-' + myBooking.mode).val().toUpperCase());
                    const bookingEmail = String($('#my-booking-email-' + myBooking.mode).val().toLowerCase());

                    $.ajax({
                        url: _d.url.signInToMyBooking,
                        type: 'POST',
                        data: {number: bookingNumber.trim(), email: btoa(bookingEmail.trim())},
                        dataType: 'json',
                        success: function(response) {
                            document.location.href = response.data.route;
                        },
                        error: function() {
                            myBooking.enableBtn();
                        }
                    });
                }
            });
        });
    },
    enableBtn: function() {
        $('.my-booking-btn').removeClass('loading');
    },
    prefix: function() {
        const env = _d.jv.env;
        // const isProduction = true;
        const isProduction = env === 'production';
        const prefixes = [_d.jv.numberPrefixJs, _d.jv.numberPrefixJsOld];
        if (!isProduction) {
            prefixes.push(_d.jv.numberPrefixTestJs, _d.jv.numberPrefixTestOldJs);
        }

        $('#my-booking-number-page')
            .on('focus', function() {
                let that = $(this);

                // Set default prefix "D" if the field is empty
                if (that.val().length === 0) {
                    that.val(_d.jv.numberPrefixJs);
                }
            })
            .on('blur', function() {
                let that = $(this);

                // Clear the field if it only contains the prefixes
                if (prefixes.includes(that.val())) {
                    that.val('');
                }
            })
            .on('input', function() {
                $(this).val(function(i, value) {
                    // Remove any characters that aren't A-Z, 0-9, or -
                    value = value.toUpperCase().replace(/[^A-Z0-9-]/g, '');

                    const patternOld = _d.jv.numberPrefixOld;
                    const pattern = _d.jv.numberPrefix;
                    const patternTestOld = _d.jv.numberPrefixTestOldJs;
                    const patternTest = _d.jv.numberPrefixTestJs;
                    const digitsPatternOld = '(\\d{0,7})';
                    const digitsPattern = '(\\d{0,9})';
                    // Prefix replacement logic
                    const prefixMapping = {
                        [_d.jv.numberPrefixDCCheckJs]: _d.jv.numberPrefixJsOld, // Replace "D" followed by "C" with "DC-"
                        [_d.jv.numberPrefixTSCheckJs]: _d.jv.numberPrefixTestOldJs // Replace "T" followed by "S" with "TS-" (only in non-production)
                    };

                    // Replace based on prefix checks
                    if (prefixMapping[value]) {
                        value = prefixMapping[value];
                    }

                    // Regex replacements for "D", "DC-", "T", "TS-"
                    const replacementRules = [
                        {
                            condition: value.startsWith(_d.jv.numberPrefixJsOld),
                            pattern: new RegExp(`^${patternOld}${digitsPatternOld}.*`),
                            replacement: _d.jv.numberReplacementOldJs
                        },
                        {
                            condition: value.startsWith(_d.jv.numberPrefixJs),
                            pattern: new RegExp(`^${pattern}${digitsPattern}.*`),
                            replacement: _d.jv.numberReplacementJs
                        },
                        {
                            condition: !isProduction && value.startsWith(_d.jv.numberPrefixTestOldJs),
                            pattern: new RegExp(`^${patternTestOld}${digitsPatternOld}.*`),
                            replacement: _d.jv.numberReplacementTestOldJs
                        },
                        {
                            condition: !isProduction && value.startsWith(_d.jv.numberPrefixTestJs),
                            pattern: new RegExp(`^${patternTest}${digitsPattern}.*`),
                            replacement: _d.jv.numberReplacementTestJs
                        }
                    ];

                    // Apply replacement rules
                    for (const rule of replacementRules) {
                        if (rule.condition) {
                            value = value.replace(rule.pattern, rule.replacement);
                            break;
                        }
                    }

                    // Check if the value starts with any valid prefix
                    const hasValidPrefix = prefixes.some(prefix => value.startsWith(prefix));

                    // Set default prefix if no valid prefix is found
                    if (!hasValidPrefix) {
                        value = _d.jv.numberPrefixJs; // Default to "D"
                    }

                    return value;
                });

            })
            .on('keydown', function(e) {
                let that = $(this);
                if (e.key === 'Backspace' || e.key === 'Delete') {
                    setTimeout(() => {
                        const value = that.val();
                        // Clear the value if it matches any valid prefix
                        if (prefixes.includes(value)) {
                            that.val('');
                        }
                    }, 0);
                }
            })
            .on('paste', function(e) {
                let that = $(this);
                e.preventDefault();

                // Get pasted data and convert it to uppercase, removing non-alphanumeric characters except dash
                let pastedData = (e.originalEvent || e).clipboardData.getData('text').toUpperCase().replace(/[^A-Z0-9-]/g, '');

                // Check if pasted data has a valid prefix
                const hasValidPrefix = prefixes.some(prefix => pastedData.startsWith(prefix));

                // Apply the correct value based on environment and prefix
                if (hasValidPrefix) {
                    that.val(pastedData); // Allow valid paste
                } else {
                    // Add default prefix if no valid prefix is found
                    that.val(_d.jv.numberPrefixJs + pastedData);
                }

                // Trigger input event to reformat the pasted data
                that.trigger('input');
            });
    },
    bookingCard: function() {
        $('.booking-card-href').on('click', function() {
            $(this).find('.my-booking-card').addClass('position-relative opening');
        });
    },
    checklist: function() {
        const instance = $('.carousel__wrapper');
        $.each( instance, function(key) {

            let arrows = $(instance[key]).find('.arrow');
            let prevArrow = arrows.filter('.arrow-prev');
            let nextArrow = arrows.filter('.arrow-next');
            let box = $(instance[key]).find('.carousel');
            let maxScrollWidth = parseInt(box[0].scrollWidth - box[0].clientWidth + 8) * -1;
            let boxItem = box.find('.carousel__item:last');
            const itemWidth = boxItem.outerWidth(true);
            const threshold= 100;
            let isDown = false;
            let startX;
            const slider = document.querySelector('.carousel');

            const isRTL = window._d && window._d.isRTL;

            if (isRTL) {
                maxScrollWidth *= -1;
            }

            const end = () => {
                isDown = false;
                slider.classList.remove('active');
            };

            const start = (e) => {
                isDown = true;
                slider.classList.add('active');
                startX = e.pageX || e.touches[0].pageX - parseInt(box.css('left'));
            };

            const move = (e) => {
                if (!isDown) { return; }

                e.preventDefault();
                const x = e.pageX || e.touches[0].pageX - parseInt(box.css('left'));
                const dist = (x - startX);
                const slides = Math.round((Math.abs(dist) + threshold) / itemWidth);
                const direction = (dist > 0 ? 'prev' : 'next');

                shiftSlide(direction, slides);
            };

            slider.addEventListener('mousedown', start);
            slider.addEventListener('touchstart', start);

            slider.addEventListener('mousemove', move);
            slider.addEventListener('touchmove', move);

            slider.addEventListener('mouseleave', end);
            slider.addEventListener('mouseup', end);
            slider.addEventListener('touchend', end);


            $(arrows).on('click', function() {
                const that = $(this);

                if (that.hasClass('disabled')) {
                    return false;
                }

                if (that.hasClass('arrow-next')) {
                    shiftSlide(isRTL ? 'prev' : 'next');
                } else {
                    shiftSlide(isRTL ? 'next' : 'prev');
                }
            });

            function shiftSlide(direction, slides) {
                slides = typeof slides !== 'undefined' ? slides : 2;
                const xValue = parseInt(box.css('left'));
                let x;

                if (direction === 'next') {
                    x = xValue - (itemWidth * slides);
                } else {
                    x = xValue + (itemWidth * slides);
                }

                if (isRTL) {
                    if (x < 0) {
                        x = 0;
                    } else if (x > maxScrollWidth) {
                        x = maxScrollWidth;
                    }
                } else if (x > 0) {
                    x = 0;
                } else if (x < maxScrollWidth) {
                    x = maxScrollWidth;
                }

                box.css('left', x);

                setTimeout(function() {
                    toggleArrows();
                }, 200);
            }

            function toggleArrows() {
                const x = parseInt(box[0].style.left);

                nextArrow.removeClass('disabled');
                prevArrow.removeClass('disabled');

                if (isRTL) {
                    if (x >= maxScrollWidth) {
                        nextArrow.addClass('disabled');
                    } else if (x <= 0) {
                        prevArrow.addClass('disabled');
                    }
                } else if (x <= maxScrollWidth) {
                    nextArrow.addClass('disabled');
                } else if (x >= 0) {
                    prevArrow.addClass('disabled');
                }
            }
        });
    },
    alternativeModal: function() {
        if (!_d.url.search.isClientAcceptDeclineAlternative) {
            return;
        }

        const modalBody = $('#alternativeCarBody');
        let modalContent;

        function onResponse(res) {
            $('.fetching-booking-loader').addClass('hide');
            $('.reservation-container').removeClass('hide');

            modalContent = res;
            modalBody
                .css('display', 'block')
                .html(modalContent);
        }

        $('#reservationViewAlternative').on('click', function(e) {
            e.preventDefault();

            const modalId = 'alternativeOffer';
            const modalElement = $(`#${modalId}`);
            const modalTitle = modalElement.data('title');
            const modalBodyContent = modalBody.html(modalContent).css('display', '');
            const containsNotAvailable = modalBodyContent.find('[data-event-action="Not available"]').length > 0;

            const modalTitleFinal = containsNotAvailable
                ? modalTitle.replace(
                    /<span[^>]*class=['"]?[^'"]*failed-reservation[^'"]*['"]?[^>]*>.*?<\/span>/g,
                    ''
                )
                : modalTitle;

            myModal.staticModal(modalId, {
                modalDialogClass: 'w-900',
                title: modalTitleFinal,
                closeOutside: true
            });

            myBooking.browseOtherCars();
            myBooking.acceptAlternativeOffer();
        });

        $.ajax({
            method: 'GET',
            url: _d.url.search.alternativeSearch
        }).done(onResponse);
    },
    browseOtherCars: function() {
        /* modal is rendered in multiple places */
        const modal = $('.modal-body#alternativeCarBody');
        const btn = modal.find('.button-v2#sb-form-search-modal-browse');

        btn.on('click', function(e) {
            e.preventDefault();

            const searchJSON = {
                is_drop_off: modal.find('#newIsDropOff').val(),
                driver_age: modal.find('#driverAge').val(),
                pick_up_country_id: modal.find('#pickUpCountryId').val(),
                pick_up_city_id: modal.find('#pickUpCityId').val(),
                pick_up_location_id: modal.find('#pickUpLocationId').val(),
                drop_off_country_id: modal.find('#dropOffCountryId').val(),
                drop_off_city_id: modal.find('#dropOffCityId').val(),
                drop_off_location_id: modal.find('#dropOffLocationId').val(),
                pickup_id: modal.find('#pickUpId').val(),
                dropoff_id: modal.find('#dropOffId').val(),
                pickup_from: modal.find('#pickUpFrom').val(),
                pickup_to: modal.find('#pickUpTo').val(),
                pick_time: modal.find('#pickTime').val(),
                drop_time: modal.find('#dropTime').val(),
                luxOnly: _d.s.luxOnly,
                residence_country: modal.find('#residenceCountry').val(),
                partner_id: modal.find('#partnerId').val(),
                another_country: '-',
                is_alternative: true
            };

            const driverDetailsJSON = modal.find('#newDriverDetailsForm').serializeArray().reduce(function(m, o) {  m[o.name] = o.value; return m; }, {});

            const post = Object.assign(searchJSON, driverDetailsJSON);

            myBooking.toggleActionsLoading(true);
            myBooking.isActionsLoading = true;

            if ($(this).hasClass('alternative-event-trigger')) {
                analyticEventTracker.sendInstantEvent('Browse_Cars_Alternative_Flow', $(this).data());
            }

            $.post(_d.url.search.createSearch, post, function(response) {
                myBooking.isActionsLoading = false;

                if (response.success) {
                    document.location.href = response.data.url;
                } else {
                    const errorHandler = $('.inline-error.in-modal');

                    $('#sb-form-submit-modal').removeClass('loading');
                    errorHandler.html('').append('<ul id="error-list-modal"></ul>');

                    $.each(response.errors.message, function(index) {
                        if (typeof response.errors.message[index] !== 'undefined') {
                            $('#error-list-modal').append('<li>' + response.errors.message[index] + '</li>');
                        }
                    });

                    $.each(response.errors.fields, function(index, value) {
                        $('#' + value + '-modal').addClass('err');
                    });

                    errorHandler.slideDown();
                }
            }, 'json');
        });
    },
    acceptAlternativeOffer: function() {
        $('.accept-alternative-btn').on('click', function(e) {
            if (myBooking.isActionsLoading) {
                e.preventDefault();
            } else {
                myBooking.toggleActionsLoading(false);
                myBooking.isActionsLoading = true;
            }
        });
    },
    toggleActionsLoading: function(isBrowseCars) {
        const modal = $('.modal-body#alternativeCarBody');
        const browseBtn = modal.find('.button-v2#sb-form-search-modal-browse');
        const acceptBtn = modal.find('.accept-alternative-btn');

        if (isBrowseCars) {
            browseBtn.addClass('loading').prop('disabled', true);
            acceptBtn.addClass('disabled');
        } else {
            browseBtn.prop('disabled', true);
            acceptBtn.addClass('loading').prop('disabled', true);
        }
    },
    modifyNotAllowedModal: function() {
        $('.modify-booking-link').on('click', function(e) {
            if (typeof isReservationModificationNotAllowed === 'undefined' || !isReservationModificationNotAllowed) {
                return;
            }

            e.preventDefault();

            myModal.staticModal('modificationNotAllowedModal', {
                modalDialogClass: 'w-744',
                closeOutside: true
            });

            $('.modification-not-allowed-close-btn').on('click', function() {
                const that = $(this);
                that.closest('.modal-content').find('.modal-close').click();
            });

            cancellation.init();
        });
    },
    // TODO: implement expire modal during next iterations
    alternativeOfferExpire: function() {
        // myModal.staticModal(
        //     'alternativeOfferExpire',
        //     {
        //         modalDialogClass: 'w-368',
        //         noHeader: true,
        //         closeOutside: true,
        //         noCloseButtonInHeader: true
        //     }
        // );

        // $('.alternative-offer-expire-button').on('click', function(e) {
        //     e.preventDefault();
        //     myModal.close();
        // });
    }
};
